import { setSelectedEvents, setSelectedAggregateEvents } from '../store/selectionStore';
import { persistantStore } from '../store/persistantStore';
import { debug, warn } from './console';

export type AssistantUiAction = {
  type: string;
  domain?: string;
  event_ids?: number[];
  label?: string;
};

export type UiActionFingerprint = {
  projectId: number;
  date: string;
  menuFamily?: string;
};

function menuFamily(menu: string | null | undefined): string {
  const m = String(menu || '')
    .toUpperCase()
    .replace(/[\s_-]+/g, '');
  if (m.includes('MANEUVER')) return 'maneuver';
  if (m.includes('PERFORMANCE')) return 'aggregate';
  return m || 'other';
}

export function currentUiActionFingerprint(): UiActionFingerprint {
  return {
    projectId: Number(persistantStore.selectedProjectId()) || 0,
    date: String(persistantStore.selectedDate() || ''),
    menuFamily: menuFamily(persistantStore.selectedMenu()),
  };
}

export function applyAssistantUiActions(
  actions: AssistantUiAction[] | undefined | null,
  expected?: UiActionFingerprint | null
): boolean {
  if (!actions?.length) return false;
  const now = currentUiActionFingerprint();
  if (expected) {
    if (expected.projectId && expected.projectId !== now.projectId) {
      warn('[Capitan] ui_action skipped — project mismatch');
      return false;
    }
    if (expected.date && now.date && expected.date !== now.date) {
      warn('[Capitan] ui_action skipped — date mismatch');
      return false;
    }
  }

  let applied = false;
  for (const action of actions) {
    if (action.type !== 'select_events') continue;
    const ids = (action.event_ids || []).map(Number).filter((n) => Number.isFinite(n));
    if (!ids.length) continue;
    const domain = action.domain || 'maneuver';
    if (domain === 'aggregate') {
      setSelectedAggregateEvents(ids);
    } else {
      setSelectedEvents(ids);
    }
    debug('[Capitan] applied select_events', { domain, count: ids.length, label: action.label });
    applied = true;
  }
  return applied;
}
